@if (isGranted()) {
  <ng-container [ngTemplateOutlet]="template()"></ng-container>
} @else {
  <app-not-granted-block></app-not-granted-block>
}
